import styled, { css, keyframes } from "styled-components";

export const Skillbody = styled.div`
height:100vh;
width:100%;
display:flex; 
justify-content:center;
align-items:center;

`
// export const Top =styled.div`
// height:10vh;
// width:calc(100% - 50px);
// display:flex; 
// gap:40px;
// padding-left:50px; 

// h1{
//     color:white;
//     margin:0;
//     font-size:4rem;
//     color:white;
//     font-weight:700;
// font-family: Franklin Ghotics Medium;
// }
// `
export const Bottom = styled.div`
position:relative;
height:100vh;
width:calc(70% - 50px);
padding-left:50px; 
display:flex; 
align-items:center;
gap:0px;

@media only screen and (max-width: 700px) {
  width:100%;
  padding-left:0;
}
`

export const SkillIcon = styled.img`
width:30%;
height:75%;
margin-top:15%;
@media only screen and (max-width: 900px) {
    display:none;
}
`


export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100vh;
  @media only screen and (max-width: 700px){
  transform:scale(.9);
}
`;

export const Header = styled.div`
  display: flex;
  width: 100%;
  height: 100px;
`;

export const LeftBox = styled.div`
  flex: 4;
  display: flex;
  justify-content: center;
  align-items: end;

  border-bottom: 4px solid black;
  padding:0;
  margin:0;

  .shelfHead{
    font-weight: bold;
    font-size:2rem;
    color:white;
    padding:0;
    margin:0;
    margin-bottom:-7px;
    letter-spacing: 2px;
    text-shadow: 2px 2px 0px #000;
  }
`;


export const Shelf = styled.div`
  display: flex;
  justify-content: space-around;
  border-bottom: 4px solid black;

`;

export const BookWrapper = styled.div`
position:relative;
  width: 120px;
  height: 120px;
  display: flex;
  justify-content: center;
  align-items: end;

  @media only screen and (max-width: 700px){
    width: 100px;
    height: 100px;
}
`;

const moveToCenter = keyframes`
  0% {
    transform: translate(0, 0) scale(1);
    z-index:999;

  }
  50% {
    transform: translate(
      calc(100% - 40px), /* 50vw minus half of book width */
      calc(10vh - 50px)  /* 50vh minus half of book height */
    ) scale(2) ;
     z-index:999;
  }
    100% {
    transform: translate(
      calc(100% - 40px), /* 50vw minus half of book width */
      calc(10vh - 50px)  /* 50vh minus half of book height */
    ) scale(2) rotateY(-180deg);
    z-index:990;

  }
`;

export const Book = styled.div`
  position:relative;
  width: 80px;
  height: 100px;
  color: green;
  border-radius: 3px;
  position: relative;
  box-shadow: 2px 2px 6px rgba(0,0,0,0.4); /* shadow for depth */
  cursor: pointer;
  
  // FLEX //
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  border-left: 5px solid darkgrey;

  // TEXT WRAP //


  transform-origin: left center; /* pivot from spine */

  /* flip when active */
  ${({ active }) => active && css`
    animation: ${moveToCenter} 1s forwards;
  `}

    ${props => props.Tcolor && `
    color: ${props.Tcolor};
  ` }
  ${props => props.cover ? `
    background: ${props.cover};
  ` : `     
    background: 
      radial-gradient(circle at 20% 30%, #fff 20%, transparent 21%),
      radial-gradient(circle at 35% 35%, #fff 25%, transparent 26%),
      radial-gradient(circle at 50% 30%, #fff 20%, transparent 21%),
      radial-gradient(circle at 65% 40%, #fff 22%, transparent 23%),
      radial-gradient(circle at 45% 45%, #fff 25%, transparent 26%);
    background-color: #87ceeb; /* sky blue */ 
  `}


  .skilllogo {
    width: 50px;
    height: 50px;
  }

  .BookTitle{
    font-family: arial;
    font-weight:bolder;
    margin:0;
    white-space: normal;
    overflow-wrap: anywhere;
    hyphens: auto;
    line-height: 1.05;
    font-size:14px;
  }

  @media only screen and (max-width: 700px){
    width: 60px;
    height: 80px;

    .skilllogo {
      width: 35px;
      height: 35px;
    }

    .BookTitle{
      font-size:11px;
    }
  } 

`;

const BackMoveToCenter = keyframes`
  0% {
    transform: translate(0, 0) scale(.8);
    z-index:989;
  
  }
  50% {
    transform: translate(
      calc(104% ), /* 50vw minus half of book width */
      calc(10vh - 50px)  /* 50vh minus half of book height */
    ) scale(2) ;
     z-index:989;
  }
    100% {
      transform: translate(
      calc(98%), /* 50vw minus half of book width */
      calc(10vh - 50px)  /* 50vh minus half of book height */
    ) scale(2) rotateY(0deg);
     z-index:990;
  }
`;
export const BookBack = styled.div`
  display:none;
  position: absolute;
  width: 80px;
  height: 100px;
  overflow:hidden;
  background: repeating-linear-gradient(
      to bottom,
      #fdfdfd,
      #fdfdfd 2px,
      #e0e0e0 3px
    );  
  backface-visibility: visible; /* allow back side to be visible */

   ${({ active }) => active && css`
      animation: ${BackMoveToCenter} 1s forwards;
   `}

   ${({ active }) => active && `
      display:flex;

   `}

     @media only screen and (max-width: 700px){
    width: 60px;
    height: 80px;
    font-size: 13px;
      overflow:hidden;

  }
`